import React, { useEffect, useState } from "react";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const CustomSelectBox = (props) => {
    const { defaultType, optionItemList, clickEvent } = props;

    const [dropdownOpen, setOpen] = useState(false);
    const toggle = () => setOpen(!dropdownOpen);
    const [defaultValue, setDefaultValue] = useState(defaultType === "TOP" ? optionItemList[0].itemName : "선택");

    const clickHandler = (item) => {
        clickEvent(item.value);
        setDefaultValue(item.itemName);
    };

    useEffect(() => {
        console.log("defaultValue====>", defaultValue);
    }, [defaultValue]);

    return (
        <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} className="selectCustom">
            <DropdownToggle id="optionfirst" className="optionfirst" caret>
                {defaultValue}
            </DropdownToggle>
            <DropdownMenu className="optionlist">
                {optionItemList.map((item, idx) => {
                    return (
                        <DropdownItem
                            key={idx}
                            onClick={() => {
                                clickHandler(item);
                            }}
                        >
                            {item.itemName}
                        </DropdownItem>
                    );
                })}
            </DropdownMenu>
        </ButtonDropdown>
    );
};
export default CustomSelectBox;
